import { useState } from 'react';
import { MobileSheet, Stack, Row, Text, Input, Button } from '../ui';
import { api } from '../api/client';

export function NewPaymentModal({ open, onClose, onSuccess, dealId, dealName }: { open: boolean; onClose: () => void; onSuccess: () => void; dealId?: string; dealName?: string }) {
  const [direction, setDirection] = useState<'AR'|'AP'>('AR');
  const [amount, setAmount] = useState('');
  const [currency, setCurrency] = useState('USD');
  const [description, setDescription] = useState('');
  const [dueAt, setDueAt] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  async function submit() {
    const amtNum = parseFloat(amount);
    if (!amtNum || amtNum <= 0) { setErr('amount must be positive'); return; }
    if (!dealId) { setErr('deal is required'); return; }
    setBusy(true); setErr('');
    try {
      await api.postPayment({ dealId, direction, amount: amtNum, currency, description: description.trim() || undefined, dueAt: dueAt ? new Date(dueAt).getTime() : undefined });
      onSuccess(); onClose();
      setAmount(''); setDescription(''); setDueAt('');
    } catch (e: any) { setErr(e.message ?? 'failed'); } finally { setBusy(false); }
  }

  return (
    <MobileSheet open={open} onClose={onClose} title="Add Expected Payment">
      <Stack gap={3}>
        {dealName && <div><Text variant="small" className="font-medium">{dealName}</Text><Text variant="label" muted>new expected payment</Text></div>}
        <Stack gap={2}>
          <Stack gap={0.5}>
            <Text variant="micro">direction</Text>
            <select value={direction} onChange={e => setDirection(e.target.value as 'AR'|'AP')} className="h-9 hairline rounded-sm px-2 bg-bg text-sm w-full">
              <option value="AR">AR - receivable (money coming in)</option>
              <option value="AP">AP - payable (money going out)</option>
            </select>
          </Stack>
          <Row gap={2}>
            <Stack gap={0.5} className="flex-1"><Text variant="micro">amount *</Text><Input value={amount} onChange={e => setAmount(e.target.value)} placeholder="0.00" type="number" className="w-full" /></Stack>
            <Stack gap={0.5} className="w-24"><Text variant="micro">currency</Text><Input value={currency} onChange={e => setCurrency(e.target.value.toUpperCase())} placeholder="USD" className="w-full" /></Stack>
          </Row>
          <Stack gap={0.5}><Text variant="micro">description</Text><Input value={description} onChange={e => setDescription(e.target.value)} placeholder="what is this payment for?" className="w-full" /></Stack>
          <Stack gap={0.5}><Text variant="micro">due date (optional)</Text><input type="date" value={dueAt} onChange={e => setDueAt(e.target.value)} className="h-9 hairline rounded-sm px-2 bg-bg text-sm w-full" /></Stack>
        </Stack>
        {err && <Text variant="small" className="text-negative">{err}</Text>}
        <Row gap={2} justify="end">
          <Button variant="ghost" onClick={onClose}>cancel</Button>
          <Button variant="primary" onClick={submit} disabled={busy}>{busy ? 'saving...' : 'add payment'}</Button>
        </Row>
      </Stack>
    </MobileSheet>
  );
}
